import { sound } from '@pixi/sound';

import { userSettingsStore } from '../../store/userSettingsStore';

import { PixiAssets } from '../../core/helpers/loadResources';

let pauseTimeOutId = null;
export const SoundTypes = {
  ReelStop: 'ReelStop',
  BackgroundMusic: 'BackgroundMusic',
  Scatter1Win: 'Scatter1Win',
  SevenSymbol: 'SevenSymbol',
  Scatter2Win: 'Scatter2Win',
  SpinButton: 'SpinButton',
  WildSymbol: 'WildSymbol',
  WildOpeningSound: 'WildOpeningSound',
  WinAccumulationSound: 'WinAccumulationSound',
  AmountIncrease: 'AmountIncrease',
  WinningLineSound: 'WinningLineSound',
  WinPopupBigWin: 'WinPopupBigWin',
  WinPopupEpicWin: 'WinPopupEpicWin',
  WinPopupMegaWin: 'WinPopupMegaWin',
  WinPopupSuperWin: 'WinPopupSuperWin',
  WinOneLineSound: 'WinOneLineSound',
  BigWinSound: 'BigWinSound',
  MegaWinSound: 'MegaWinSound',
  SuperWinSound: 'SuperWinSound',
  EpicWinSound: 'EpicWinSound',
  MaxWinSound: 'MaxWinSound',
  JackpotSymbolSound: 'JackpotSound',
  JackpotSymbol: 'JackpotSymbol',
  JackpotBackgroundMusic: 'JackpotBackgroundMusic',
  JackpotIlluminations: 'Illuminations',
  JackpotSceneTransition: 'SceneTransition',
  JackpotSuitAppearance: 'SuitAppearance',
  JackpotSuitTransfer: 'SuitTransfer',
  JackpotWinPopUp: 'WinPopUp',
  OpenWheel: 'OpenWheel',
  WheelWinPopup: 'WheelWinPopup',
};

export const soundOptions = [
  {
    path: 'sounds1/reelStop.mp3',
    name: SoundTypes.ReelStop,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/spinButton.mp3',
    name: SoundTypes.SpinButton,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/wildSymbol.mp3',
    name: SoundTypes.WildSymbol,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/bigWinSound.mp3',
    name: SoundTypes.BigWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/megaWinSound.mp3',
    name: SoundTypes.MegaWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/epicWinSound.mp3',
    name: SoundTypes.EpicWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/superWinSound.mp3',
    name: SoundTypes.SuperWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/maxWinSound.mp3',
    name: SoundTypes.MaxWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/wildOpeningSound.mp3',
    name: SoundTypes.WildOpeningSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/winningLineSound.mp3',
    name: SoundTypes.WinningLineSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/amountIncrease.mp3',
    name: SoundTypes.AmountIncrease,
    autoplay: false,
    html5: true,
  },
  // {
  //   path: 'sounds1/winOneLineSound.mp3',
  //   name: SoundTypes.WinOneLineSound,
  //   autoplay: false,
  //   html5: true,
  // },
  {
    path: 'sounds1/backgroundMusic.mp3',
    name: SoundTypes.BackgroundMusic,
    autoplay: true,
    loop: true,
    html5: true,
  },
  {
    path: 'sounds1/winPopupBigWin.mp3',
    name: SoundTypes.WinPopupBigWin,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/jackpotSymbolSound.mp3',
    name: SoundTypes.JackpotSymbolSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/jackpotBackgroundMusic.mp3',
    name: SoundTypes.JackpotBackgroundMusic,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/illuminations.mp3',
    name: SoundTypes.JackpotIlluminations,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/sceneTransition.mp3',
    name: SoundTypes.JackpotSceneTransition,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/suitAppearance.mp3',
    name: SoundTypes.JackpotSuitAppearance,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/suitTransfer.mp3',
    name: SoundTypes.JackpotSuitTransfer,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/winPopUp.mp3',
    name: SoundTypes.JackpotWinPopUp,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/jackpot_Symbol.mp3',
    name: SoundTypes.JackpotSymbol,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/starScatterWin.mp3',
    name: SoundTypes.Scatter2Win,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/dollarScatterWin.mp3',
    name: SoundTypes.Scatter1Win,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/openWheel.mp3',
    name: SoundTypes.OpenWheel,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds1/wheelWinPopup.mp3',
    name: SoundTypes.WheelWinPopup,
    autoplay: false,
    html5: true,
  },
];

const SoundListNames = soundOptions.map((el) => el.name);

class SoundService {
  async play(name, config = {}) {
    if (userSettingsStore.isSoundOn) PixiAssets.get(name).play(config);
  }

  async stop(name) {
    PixiAssets.get(name).stop();
  }

  stopAll() {
    const SoundList = Object.values(PixiAssets.get(SoundListNames));
    SoundList.forEach((sound) => {
      sound.stop();
    });
  }

  stopAllSounds() {
    const SoundList = Object.values(PixiAssets.get(SoundListNames));
    SoundList.forEach((sound) => {
      if (!sound.options.url.includes('Music')) {
        sound.stop();
      }
    });
  }

  playMusic() {
    if (userSettingsStore.isSoundOn) {
      this.play(SoundTypes.BackgroundMusic, { loop: true });
    }
  }

  pauseSounds() {
    clearTimeout(pauseTimeOutId);
    // this.stopAll();
    sound.pauseAll();
  }

  resumeSounds() {
    clearTimeout(pauseTimeOutId);
    pauseTimeOutId = setTimeout(() => {
      // this.stopAll();
      //sound.resume(SoundTypes.BackgroundMusic);
    }, 2000);
  }
}

const soundService = new SoundService();

export { SoundTypes as soundTypes, soundService };
